if (!customElements.get('esfari-personalisation')) {
  customElements.define('esfari-personalisation', class extends HTMLElement {
    connectedCallback() {
      this.selector = this.querySelector('[data-esfari-engraving]');
      this.onChoice = () => this.updateFields();
      this.onFile = () => {
        const file = this.querySelector('[type="file"]').files[0];
        this.querySelector('[data-upload-status]').textContent = file ? 'Geselecteerd: ' + file.name : '';
      };
      this.selector?.addEventListener('change', this.onChoice);
      this.querySelector('[type="file"]').addEventListener('change', this.onFile);
      this.updateFields();
    }
    disconnectedCallback() {
      this.selector?.removeEventListener('change', this.onChoice);
      this.querySelector('[type="file"]')?.removeEventListener('change', this.onFile);
    }
    updateFields() {
      const type = this.dataset.fixedType || this.selector?.value || '';
      this.querySelectorAll('[data-engraving-field]').forEach(group => {
        const active = group.dataset.engravingField.split(',').includes(type);
        group.hidden = !active;
        group.querySelectorAll('input, select').forEach(input => {
          input.disabled = !active;
          input.required = active;
        });
      });
      const text = this.querySelector('[data-engraving-text]');
      const labels = { Naam: 'Vul je naam in', Letter: 'Vul je letter in', Initialen: 'Vul je initialen in (maximaal 2)', Symbool: 'Welk symbool wil je laten graveren?' };
      this.querySelector('[data-engraving-label]').textContent = labels[type] || 'Vul je gravure in';
      text.name = 'properties[' + (labels[type] ? type : 'Gravuretekst') + ']';
      text.removeAttribute('pattern');
      text.removeAttribute('title');
      text.placeholder = '';
      const help = this.querySelector('[data-engraving-help]');
      help.hidden = !['Letter', 'Initialen'].includes(type);
      if (type === 'Letter' || type === 'Initialen') {
        text.maxLength = type === 'Letter' ? 1 : 2;
        text.pattern = type === 'Letter' ? '[A-Za-z]{1}' : '[A-Za-z]{1,2}';
        text.title = type === 'Letter' ? 'Vul 1 letter in (A–Z).' : 'Vul 1 letter of maximaal 2 initialen in (A–Z).';
        text.placeholder = type === 'Letter' ? 'Bijvoorbeeld M' : 'Bijvoorbeeld MJ';
        help.textContent = type === 'Letter' ? 'Voer 1 letter in (A–Z).' : 'Voer 1 letter of maximaal 2 initialen in (A–Z).';
      } else {
        text.removeAttribute('maxlength');
      }
    }
  });
}
